import * as PIXI from "pixi.js";
import Panel from "../Panel/Panel";


export default class ResultsConRenderer extends PIXI.Container {
  private Panel = Panel.getInstance();
  private header = this.addChild(new PIXI.Text());
  private resultText = this.addChild(new PIXI.Text());

  constructor() {
    super();
    this.addHeaderDetails();
    this.addResultTextDetails();
    this.addToPanel();

    this.y = 225;
  }

  private addToPanel = () => this.Panel.addChild(this);
  private addHeaderDetails() {
    this.header.text = "Results";
    this.header.anchor.set(.5);
    this.header.y = -64;
    this.header.style.fontSize = 34;
  }
  private addResultTextDetails() {
    this.resultText.text = "You answered 16 out of 20 questions correctly. You received a total score of 80 points.";
    this.resultText.anchor.set(.5);
    this.resultText.y = 0;
    this.resultText.style = {
      wordWrap: true,
      wordWrapWidth: 520,
      fontSize: 24
    }
  }
  setResult(questionCount: number, trueAnswerCount: number, puan: number) {
    this.resultText.text = `You answered ${trueAnswerCount} out of ${questionCount} questions correctly. You received a total score of ${puan} points.`
  }
}